"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import { MessageCircle, X, ExternalLink } from "lucide-react";
import { api } from "@/lib/api-client";

// Widget bantuan mengambang untuk dashboard siswa. Membaca /api/public/support
// (nomor WA admin + help links). Tampil hanya bila ada nomor WA atau help link.
// Dikonfigurasi admin di /admin/website → tab Dukungan → "Kontak Bantuan".

interface SupportData {
  wa_admin_number?: string;
  wa_greeting?: string;
  help_links?: {
    label: string;
    url: string;
  }[];
}

/** 08xx / +62xx / 62xx → 62xx untuk wa.me. */
function toWaLink(num: string, greeting?: string): string {
  let n = num.replace(/[^\d+]/g, "");
  if (n.startsWith("+")) n = n.slice(1);
  if (n.startsWith("0")) n = `62${n.slice(1)}`;
  const base = `https://wa.me/${n}`;
  return greeting ? `${base}?text=${encodeURIComponent(greeting)}` : base;
}
export default function HelpWidgetButton() {
  const $ = _c(16);
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      let alive = true;
      api("/api/public/support").then(res => {
        if (alive && res.success && res.data) {
          setData(res.data);
        }
      }).catch(_temp);
      return () => {
        alive = false;
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const hasWa = !!data?.wa_admin_number;
  let t2;
  if ($[2] !== data?.help_links) {
    t2 = data?.help_links ?? [];
    $[2] = data?.help_links;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const links = t2;
  if (!hasWa && links.length === 0) {
    return null;
  }
  let t3;
  if ($[4] !== data || $[5] !== hasWa || $[6] !== links || $[7] !== open) {
    t3 = open && <div className="w-64 rounded-2xl border border-black/10 bg-white p-3 shadow-xl"><div className="mb-2 flex items-center justify-between"><span className="text-sm font-semibold text-gray-800">Butuh bantuan?</span><button type="button" onClick={() => setOpen(false)} className="rounded-lg p-1 text-gray-400 hover:bg-gray-100" aria-label="Tutup"><X className="h-4 w-4" /></button></div>{hasWa && <a href={toWaLink(data.wa_admin_number, data?.wa_greeting)} target="_blank" rel="noopener noreferrer" className="mb-1 flex items-center gap-2 rounded-xl bg-emerald-500 px-3 py-2 text-sm font-medium text-white hover:bg-emerald-600"><MessageCircle className="h-4 w-4" /> Chat Admin (WhatsApp)</a>}{links.map(_temp2)}</div>;
    $[4] = data;
    $[5] = hasWa;
    $[6] = links;
    $[7] = open;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setOpen(_temp3);
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      backgroundColor: "var(--brand-primary, #0F6E56)"
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== open) {
    t6 = <button type="button" onClick={t4} className="flex h-12 w-12 items-center justify-center rounded-full text-white shadow-lg transition hover:scale-105" style={t5} aria-label="Bantuan">{open ? <X className="h-5 w-5" /> : <MessageCircle className="h-5 w-5" />}</button>;
    $[11] = open;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t3 || $[14] !== t6) {
    t7 = <div className="fixed bottom-[calc(var(--nav-h)+0.75rem)] right-4 z-[var(--z-fab)] flex flex-col items-end gap-3 md:bottom-5 md:right-5">{t3}{t6}</div>;
    $[13] = t3;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}
function _temp3(v) {
  return !v;
}
function _temp2(l, i) {
  return <a key={i} href={l.url} target="_blank" rel="noopener noreferrer" className="flex items-center justify-between gap-2 rounded-xl px-3 py-2 text-sm text-gray-700 hover:bg-gray-100"><span className="truncate">{l.label}</span><ExternalLink className="h-3.5 w-3.5 shrink-0 text-gray-400" /></a>;
}
function _temp() {}